var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-weight-medium text-center px-2",class:{
		red: _vm.ambiente === 'Staging' || _vm.ambiente === 'Contingência',
		'bg-roxo-almode': _vm.ambiente !== 'Staging'
	}},[_c('span',{staticClass:"white--text"},[_vm._v(" "+_vm._s(_vm.ambiente)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }